import { Divider, Scrollable, Typography } from '@lyearn/ui';

import SortMenuItem from '../SortMenuItem';
import { BaseSortMenuItem, SortMenuItemsProps } from './types';

const SortMenuItemsMobile = <T extends BaseSortMenuItem>(props: SortMenuItemsProps<T>) => {
  const { items, label, value, onAction } = props;

  return (
    <>
      {label ? (
        <Typography
          as="p"
          className="native:pt-8 px-24 pt-32 pb-20"
          color="text-text-primary"
          variant="heading-s">
          {label}
        </Typography>
      ) : null}
      <Divider color="border-divider" size={1} />
      <Scrollable className="ios:insert-padding-bottom-screen android:pb-18 space-y-4 px-8 pt-10 pb-24">
        {items.map((item) => (
          <SortMenuItem
            key={item.id}
            isSelected={item.id === value}
            item={item}
            onAction={onAction}
          />
        ))}
      </Scrollable>
    </>
  );
};

export default SortMenuItemsMobile;
